import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import { useLocation } from "@reach/router"

import Layout from "../../components/Layout"
import CampaignFooter from "../../components/campaign/CampaignFooter"
import WhiteLogo from "../../images/logo/premagic-logo-white.svg"

const SKELETON_HTML = `
<div style="background:#fff;border-radius:16px;padding:16px;margin:auto;width:400px;">
  <div class="premagic-widget-loading-sk" style="height:300px"></div>
  <div style="height:16px;"></div>
  <div style="display:flex;gap:16px;">
    <div class="premagic-widget-loading-sk"></div>
  </div>
</div>
<style>
.premagic-widget-loading-sk{flex:1;height:40px;width:100%;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%);background-size:200% 100%;border-radius:16px;animation:premagic-shimmer 1.5s infinite;}
@keyframes premagic-shimmer{0%{background-position:-200% 0;}100%{background-position:200% 0;}}
</style>
`

export default function ThankyouPage() {
  const location = useLocation()
  const [userName, setUserName] = useState("You")
  const [eventName, setEventName] = useState("your event")

  useEffect(() => {
    if (typeof window === "undefined") return
    const params = new URLSearchParams(window.location.search)
    const userNameParam = params.get("USER_NAME")
    const eventNameParam = params.get("event_name")
    if (userNameParam) setUserName(userNameParam)
    if (eventNameParam) setEventName(eventNameParam)
  }, [location.search])

  useEffect(() => {
    if (typeof window === "undefined") return
    const params = new URLSearchParams(window.location.search)
    const w = window as any
    w.PM_config = {
      shareId: "CampaignThankyou-DO-NOT-EDIT",
      embedWidgetFlow: "poster_creation",
      type: "ATTENDEE",
      widgetStyle: "preview",
      prefillData: {
        userName: params.get("USER_NAME") || "",
        event_name: params.get("event_name") || "",
      },
    }
    w.premagic =
      w.premagic ||
      function (...args: unknown[]) {
        ;(w.premagic.q = w.premagic.q || []).push(args)
      }
    let script = document.getElementById(
      "premagic"
    ) as HTMLScriptElement | null
    if (!script) {
      script = document.createElement("script")
      script.id = "premagic"
      script.src =
        "https://asts.premagic.com/s/poster-widget/premagic-poster-widget.js"
      script.defer = true
      script.type = "module"
      document.body.appendChild(script)
    }
    w.premagic("init", w.PM_config)
  }, [location.search])

  return (
    <Layout title="Thank you" noIndex={true} hasFooter={false}>
      <div className="min-h-screen bg-white flex flex-col items-center px-4 py-10 gap-8">
        <div className="w-full max-w-[480px] flex flex-col items-center gap-3 text-center">
          <h1
            className="font-primary font-semibold text-text-primary"
            style={{
              fontSize: "clamp(28px, 6vw, 40px)",
              lineHeight: "110%",
              letterSpacing: "-0.03em",
            }}
          >
            {userName}, you made {eventName} what it was.
          </h1>
          <p className="text-text-secondary text-[16px] font-normal leading-[160%]">
            The team behind it deserves to hear it from you.
          </p>
        </div>

        <style>{`
          #widget-premagic button,
          #widget-premagic input[type="button"],
          #widget-premagic input[type="submit"] {
            background-color: revert;
            background-image: revert;
          }
        `}</style>
        <div className="w-full overflow-x-auto flex justify-center">
          <div
            id="widget-premagic"
            dangerouslySetInnerHTML={{ __html: SKELETON_HTML }}
          />
        </div>

        <div className="w-full max-w-[342px] sm:max-w-[480px] bg-primary-soft rounded-2xl px-4 py-6 flex flex-col items-center gap-4 text-center">
          <img src={WhiteLogo} alt="Premagic" width={119} />
          <div className="flex flex-col gap-2">
            <h2 className="font-primary font-semibold text-[#F5F1E8] text-[24px] leading-[130%]">
              Do you organise events?
            </h2>
            <p className="text-[#F5F1E8] text-[16px] font-normal leading-[160%]">
              Your attendees are your best marketers. Premagic helps you
              activate them.
            </p>
          </div>
          <Link
            to="/request-a-demo/"
            className="w-full flex items-center justify-center bg-primary-dark text-text-white font-primary font-semibold text-[14px] rounded-xl h-[45px]"
          >
            See How it Works
          </Link>
        </div>

        <CampaignFooter eventName={eventName} />
      </div>
    </Layout>
  )
}
